import { useSelector } from 'react-redux'

import { selectTerritory } from '@/features/domain/territory'

import { BulkTimeWindowField } from '../../primitives/BulkTimeWindowField'

import { form } from '../../../formState'
import { FormData } from '../../../types'

import { createValidateTimeWindows } from './hooks/createValidateTimeWindows'
import { useTexts } from './hooks/useTexts'

export function TimeWindows() {
  const texts = useTexts()
  const territory = useSelector(selectTerritory)

  form.useAddFieldValidation('timeWindows', (field, _formApi) => {
    const timeWindowsValidationMessage = createValidateTimeWindows(texts, field.value, territory)
    return timeWindowsValidationMessage
  })

  return (
    <BulkTimeWindowField<'timeWindows', FormData>
      name="timeWindows"
      bulkTimeWindowProps={{
        testId: 'order-timeWindows',
        label: texts.timeWindows,
      }}
    />
  )
}
